import React from "react";
import PropTypes from "prop-types";

function MediaOutletResult({ gid }) {
  return <div>MediaOutlet: {JSON.stringify(gid)}</div>;
}

MediaOutletResult.propTypes = {
  gid: PropTypes.string.isRequired,
};
export default MediaOutletResult;
